import React, {useMemo} from "react";
import {CustomsRequirement} from "~/apps/packages/customs-requirements/queries";
import {SelectChipInput} from "~/apps/core/ui/ChipInput/SelectChipInput"
import {humanizeCustomsRequirementScreenType} from "~/apps/packages/customs-requirements/utils";
const STATUSES: CustomsRequirement["screeningType"][] = [
    "МИДК",
    "Физический",
    "Взвешивание",
];


export type CustomsRequirementTypeChipInputProps = {
    value?: CustomsRequirement["screeningType"]
    onChange?: (value: CustomsRequirement["screeningType"]) => any
    disabled?: boolean
}


export const CustomsRequirementTypeChipInput = (props: CustomsRequirementTypeChipInputProps) => {
    const options = useMemo(() => STATUSES.map(status => ({
        value: status,
        title: humanizeCustomsRequirementScreenType(status),
    })).concat([
        {
            title: "Все",
            value: null
        }
    ]), []);

    const title = "Тип";
    const label = useMemo(() => {
        return options.find(x => x.value == props.value)?.title || title;
    }, [options, props.value])

    return (
        <SelectChipInput {...props} title={title} label={label} options={options}/>
    )
}